import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CapacitorBarcodeScanner, CapacitorBarcodeScannerTypeHintALLOption } from '@capacitor/barcode-scanner';
import { I18nService } from '../shared/i18n.service';

@Component({
    selector: 'app-scan-camera',
    templateUrl: './scan-camera.page.html',
    styleUrls: ['./scan-camera.page.scss'],
    standalone: false
})
export class ScanCameraPage implements OnInit {

    constructor(
        public viewCtrl: ModalController,
        public i18n: I18nService,
    ) { }

    ngOnInit() {
    }

    async ionViewWillEnter() {
        try {
            const result = await CapacitorBarcodeScanner.scanBarcode({
                hint: CapacitorBarcodeScannerTypeHintALLOption.ALL,
                scanInstructions: this.i18n.tr('[en]Scan a barcode'),
                scanButton: false,
                scanText: this.i18n.tr('[en]Scanning...')
            });

            if (result.ScanResult) {
                this.viewCtrl.dismiss({code: result.ScanResult});
            } else {
                this.viewCtrl.dismiss();
            }
        } catch (error) {
            console.error('Barcode scan error:', error);
            this.viewCtrl.dismiss();
        }
    }

    ionViewWillLeave() {
        // Clean up if needed
    }

    doCancel() {
        this.viewCtrl.dismiss();
    }
}
